import { SearchFiltersBodyType } from '../../components/search-filters-body-type/search-filters-body-type'
import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'

export const BodyTypeCars = withFacetContext(
    FacetName.body_type,
    withFilterContext(FilterName.body_type, SearchFiltersBodyType, {
        title: 'Body type',
    })
)
